import { Component, OnInit, Input } from '@angular/core';
import * as _ from "lodash";

@Component({
  selector: 'result-tree',
  templateUrl: './result-tree.component.html',
  styleUrls: ['./result-tree.component.scss']
})
export class ResultTreeComponent implements OnInit {

  @Input() recepiesToProcess;
  @Input() substitudes;

  public result = [];
  public totalValue = [];

  constructor() { }

  ngOnInit(): void {
    this.recepiesToProcess.forEach(recipe => {
      let res = {
        hasChange: false,
        recipe: recipe,
        ingredients: []
      };

      recipe.Ingredients.forEach(ing => {
        let ingredient = {
          rowColor: '#ffffff',
          hasChange: false,
          ingredient: ing,
          replace: null,
        };

        this.substitudes.forEach(subs => {
          //замяна
          if(!_.isNull(subs.source.product) 
          && ing.Material['@odata.id'] == subs.source.product['@odata.id']
          && (_.isNull(subs.source.quantity) || ing.UsageQuantity['Value'] == subs.source.quantity)
          ) {
            ingredient.replace = subs.replace;
            ingredient.rowColor = _.isNull(subs.replace.product) ? '#e6272733' /* maham go */ : '#8bc34a'/* promenqm go */;
            ingredient.hasChange = true;
            res.hasChange = true;
          }

        });

        res.ingredients.push(ingredient);
      })

      this.substitudes.forEach(subs => {
        //нов ред
        if(_.isNull(subs.source.productName) && !_.isNull(subs.replace.productName)) {
          let ingredient = {
            hasChange: true,
            rowColor: '#e6c52726',
            ingredient: null,
            replace: subs.replace,
          };

          res.hasChange = true;
          res.ingredients.push(ingredient);
        }

      });

      this.result.push(res);

      let value = 0
      res.ingredients.forEach(ingredient => {
        value += ingredient?.replace?.quantity * ingredient?.replace?.product?.StandardCostPerLot?.Value;
      });

      this.totalValue.push(value);
    });
  }

}
